import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {DjangoPage} from '../../django-paginator';
import {CommunityPage} from '../../admin/pages/pages-api.service';

export interface PageSearch {
  uuid: string;
  name: string;
  profile_photo: ProfilePhoto;
  type: string;
}

interface ProfilePhoto {
  id: number;
  url: string;
  thumbnail: string;
  width: number;
  height: number;
}

@Injectable()
export class PageSearchService {
  constructor(private http: HttpClient) {}

  getPages = (params = null) => {
    // return this.http.get<DjangoPage<CommunityPage>>('/rest-api/v1/community/admin/pages', {params});
    return this.http.post<DjangoPage<CommunityPage>>('/rest-api/v2/search/universal', params);
  };

  getPageDetails = (uuid: string) => this.http.get(`/rest-api/v1/community/admin/pages/${uuid}`);
}
